import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import api from "../services/api";
import { ActivityTableSkeleton } from "../components/ui/PageContentSkeleton";
import ActivityLogListItem from "../components/activity/ActivityLogListItem";

export default function MyActivity() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [entityFilter, setEntityFilter] = useState("");
  const [actionFilter, setActionFilter] = useState("");

  useEffect(() => {
    fetchLogs();
  }, [entityFilter, actionFilter]);

  const fetchLogs = async () => {
    setLoading(true);
    try {
      const params = {};
      if (entityFilter) params.entityType = entityFilter;
      if (actionFilter) params.action = actionFilter;
      const res = await api.get("/activity-logs/me", { params });
      setLogs(Array.isArray(res.data?.data) ? res.data.data : (Array.isArray(res.data) ? res.data : []));
    } catch (err) {
      toast.error(err.response?.data?.error || "Failed to load activity");
      setLogs([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-6xl mx-auto">
      <div className="mb-6 flex flex-wrap items-center justify-between gap-4">
        <div>
          <h1 className="text-3xl font-bold text-primary mb-1">My Activity</h1>
          <p className="text-gray-600">
            Actions where you are the actor or the affected user. When you act for someone else, their name
            appears as the affected user.
          </p>
        </div>
        <div className="flex flex-wrap gap-2">
          <select
            value={entityFilter}
            onChange={(e) => setEntityFilter(e.target.value)}
            className="border border-gray-200 rounded-lg px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary w-full sm:w-auto"
          >
            <option value="">All types</option>
            <option value="goal">Goals</option>
            <option value="employee">Employees</option>
            <option value="leave">Leave</option>
            <option value="expense">Expenses</option>
            <option value="attendance">Attendance</option>
            <option value="department">Departments</option>
            <option value="holiday">Holidays</option>
            <option value="user">Users</option>
            <option value="profile">Profile</option>
          </select>
          <select
            value={actionFilter}
            onChange={(e) => setActionFilter(e.target.value)}
            className="border border-gray-200 rounded-lg px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary w-full sm:w-auto"
          >
            <option value="">All actions</option>
            <option value="goal_created">Goal created</option>
            <option value="goal_updated">Goal updated</option>
            <option value="goal_comment_added">Goal comment</option>
            <option value="employee_created">Employee created</option>
            <option value="holiday_created">Holiday created</option>
            <option value="holiday_updated">Holiday updated</option>
            <option value="holiday_deleted">Holiday deleted</option>
            <option value="leave_requested">Leave requested</option>
            <option value="leave_approved">Leave approved</option>
            <option value="leave_rejected">Leave rejected</option>
            <option value="expense_requested">Expense requested</option>
            <option value="expense_approved">Expense approved</option>
            <option value="attendance_checked_in">Check in</option>
            <option value="attendance_checked_out">Check out</option>
          </select>
        </div>
      </div>

      {loading ? (
        <ActivityTableSkeleton />
      ) : logs.length === 0 ? (
        <div className="bg-white rounded-xl shadow p-8 text-center text-gray-500">No activity logs found.</div>
      ) : (
        <div className="bg-white rounded-xl shadow p-6">
          <ul className="space-y-2">
            {logs.map((log) => (
              <ActivityLogListItem key={log.id} entry={log} />
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
